import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Lock, FileCheck2, Globe2 } from "lucide-react";

export default function LegalLayout({ title, subtitle, lastUpdate, children }) {
    return (
        <main data-testid="legal-page" className="bg-white">
            <header className="bg-[#1A1A1A] text-[#F4F1EA] pt-28 md:pt-36 pb-20">
                <div className="max-w-[920px] mx-auto px-6 md:px-12">
                    <Link
                        to="/"
                        data-testid="legal-back-link"
                        className="inline-flex items-center gap-2 text-xs tracking-[0.24em] uppercase text-[#A4A19A] hover:text-[#8B6914] transition-colors"
                    >
                        <ArrowLeft size={14} /> Volver al inicio
                    </Link>
                    <h1 className="font-serif-display mt-10 text-4xl md:text-6xl tracking-tight text-[#F4F1EA] leading-[1.05]">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="mt-6 font-serif-display italic text-lg md:text-xl text-[#A4A19A] max-w-[640px]">
                            {subtitle}
                        </p>
                    )}
                    {lastUpdate && (
                        <p className="mt-10 text-xs tracking-[0.24em] uppercase text-[#8B6914]">
                            Última actualización · {lastUpdate}
                        </p>
                    )}
                </div>
            </header>

            <article className="max-w-[760px] mx-auto px-6 md:px-12 py-20 md:py-28 prose-legal">
                {children}
            </article>

            <SealsStrip />
        </main>
    );
}

function SealsStrip() {
    const seals = [
        {
            icon: <ShieldCheck size={28} className="text-[#8B6914]" />,
            t: "RGPD · GDPR",
            d: "Reglamento (UE) 2016/679. Tratamiento conforme a la normativa europea de protección de datos personales.",
        },
        {
            icon: <Lock size={28} className="text-[#8B6914]" />,
            t: "ISO/IEC 27001",
            d: "Marco de gestión de seguridad de la información aplicado a infraestructura, accesos y ciclo de vida del dato.",
        },
        {
            icon: <FileCheck2 size={28} className="text-[#8B6914]" />,
            t: "ePrivacy · LSSI-CE",
            d: "Cumplimiento de la Directiva 2002/58/CE y de la Ley 34/2002 española en comunicaciones electrónicas y cookies.",
        },
        {
            icon: <Globe2 size={28} className="text-[#8B6914]" />,
            t: "UAE PDPL · DIFC DP Law 2020",
            d: "Federal Decree-Law nº 45/2021 y Dubai International Financial Centre Data Protection Law 2020 para datos tratados en EAU.",
        },
    ];
    return (
        <section
            data-testid="legal-seals"
            className="bg-[#F4F1EA] border-t border-[#E5E0D5]"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-16 md:py-24">
                <p className="overline mb-3">Marcos de cumplimiento</p>
                <h2 className="font-serif-display text-2xl md:text-4xl tracking-tight text-[#1A1A1A] leading-tight max-w-[760px]">
                    Operamos bajo los estándares más exigentes de protección de datos y seguridad de la información.
                </h2>
                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E0D5] border border-[#E5E0D5]">
                    {seals.map((s) => (
                        <div
                            key={s.t}
                            data-testid={`seal-${s.t.split(" ")[0].toLowerCase()}`}
                            className="bg-white p-8"
                        >
                            <div>{s.icon}</div>
                            <p className="mt-5 font-serif-display text-xl text-[#1A1A1A] leading-tight">
                                {s.t}
                            </p>
                            <p className="mt-3 text-sm text-[#666666] leading-[1.7]">{s.d}</p>
                        </div>
                    ))}
                </div>
                <p className="mt-10 text-xs text-[#666666] leading-[1.7] max-w-[820px]">
                    Las referencias anteriores describen los marcos normativos aplicables y la
                    metodología de cumplimiento adoptada por Aurum Vanguard. La acreditación
                    formal por organismos certificadores se actualizará en esta página a medida
                    que cada certificación complete su auditoría externa.
                </p>
            </div>
        </section>
    );
}
